const SvgSoftware2 = (props) => (
  <>
    <path d="m0 0 48 48L0 96V0zM48 0l48 48-48 48V0z" fill={props.p40} />
  </>
);

export default SvgSoftware2;
